<h2 mat-dialog-title>{{data.title}}</h2>
<mat-dialog-content>{{data.message}}</mat-dialog-content>
<mat-dialog-actions>
  <button mat-button (click)="onCancel()">Cancel</button>
  <button mat-button color="warn" (click)="onConfirm()">Confirm</button>
</mat-dialog-actions>
